import { Button, EmptyStateBase, Page } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export default function ImpersonationEnded() {
  const { t } = useTranslation();

  return (
    <Page>
      <EmptyStateBase
        emoji={":wave:"}
        title={t("core:impersonation_ended_title")}
        description={t("core:impersonation_ended_description")}
        primaryButton={
          <Button variant={"secondary"} onClick={() => window.close()}>
            {t("core:impersonation_ended_close")}
          </Button>
        }
      />
    </Page>
  );
}
